<template>
    <div class="no-results-wrapper">
        <div class="no-results">
            <span class="icon-ticket no-results__icon"></span>
            <p class="no-results__message">{{noResultsCopy}}</p>
            <p
                v-if="noResultsSecondaryCopy"
                class="no-results__secondary-message"
            >
                {{noResultsSecondaryCopy}}
            </p>
            <router-link
                v-if="showRedirect"
                class="no-results__cta"
                tag="button"
                to="/"
            >
                {{redirectCopy}}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        noResultsCopy: {
            type: String,
            default: 'No Events Found'
        },
        noResultsSecondaryCopy: {
            type: String
        },
        redirectCopy: {
            type: String,
            default: 'See All Events'
        },
        showRedirect: {
            type: Boolean,
            default: true
        }
    }
}

</script>
<style lang="postcss" scoped>
@import 'theme';

.no-results-wrapper {
    background-color: #FFFFFF;
    border-radius: 4px;
    box-shadow: none;
    padding-bottom: 24px;
    padding-top: 32px;
    text-align: center;
    @media (--mq-large-min) {
        box-shadow: 0 1px 6px 0 rgba(0,0,0,0.3);
    }
}

.no-results {
    & .no-results__icon {
        color: #A2AAAD;
        font-size: 32px;
        @media (--mq-large-min) {
            font-size: 48px;
        }
    }

    & .no-results__message {
        color: #444649;
        font-size: 20px;
        font-weight: 300;
        margin: 0;
    }

    & .no-results__secondary-message {
        color: #444649;
        font-size: 14px;
        margin: 8px 0 -10px 0;
    }

    & .no-results__cta {
        background-color: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #255F82;
        color: #255F82;
        font-size: 16px;
        font-weight: 300;
        margin-top: 26px;
        padding: 6px 16px;

        &:hover {
            cursor: pointer;
        }
    }

}

</style>
